module.exports = __webpack_public_path__ + "media/images/paid-9ddc97fcca79198711f7bc417a76e408.png";